import { c as _c } from "react/compiler-runtime";
import { createFileRoute, getRouteApi, useNavigate } from '@tanstack/react-router';
import { Dashboard } from '@/idv2/features/auth-methods/dashboard';
import { getLogger } from '@/idv2/utils/logger';
const {
  logTrack
} = getLogger({
  name: 'idv2',
  location: 'auth-methods-dashboard'
});
const parentRoute = getRouteApi('/auth-methods');
export const Route = createFileRoute('/auth-methods/')({
  component: AuthMethodsDashboard
});
function AuthMethodsDashboard() {
  const $ = _c(23);
  const navigate = useNavigate();
  const {
    onAuthMethodsDone
  } = Route.useRouteContext();
  const {
    authMethods,
    decryptedEmail,
    decryptedPhone,
    deviceInfo
  } = parentRoute.useLoaderData();
  const isInIframe = typeof window !== "undefined" && window.self !== window.top;
  let t0;
  if ($[0] !== authMethods) {
    t0 = kind => {
      const method = authMethods.find(m => m.kind === kind);
      return method?.isVerified ? "replace" : "add_primary";
    };
    $[0] = authMethods;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getActionKind = t0;
  let t1;
  if ($[2] !== decryptedEmail || $[3] !== getActionKind || $[4] !== navigate) {
    t1 = () => {
      const actionKind = getActionKind("email");
      logTrack(`User clicked ${actionKind} email`);
      navigate({
        to: "/auth-methods/update-email",
        search: {
          actionKind,
          currentEmail: decryptedEmail
        }
      });
    };
    $[2] = decryptedEmail;
    $[3] = getActionKind;
    $[4] = navigate;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleEmailClick = t1;
  let t2;
  if ($[6] !== getActionKind || $[7] !== navigate) {
    t2 = () => {
      const actionKind_0 = getActionKind("phone");
      logTrack(`User clicked ${actionKind_0} phone`);
      navigate({
        to: "/auth-methods/update-phone",
        search: {
          actionKind: actionKind_0
        }
      });
    };
    $[6] = getActionKind;
    $[7] = navigate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handlePhoneClick = t2;
  let t3;
  if ($[9] !== getActionKind || $[10] !== navigate) {
    t3 = () => {
      const actionKind_1 = getActionKind("passkey");
      logTrack(`User clicked ${actionKind_1} passkey`);
      navigate({
        to: "/auth-methods/update-passkey",
        search: {
          actionKind: actionKind_1
        }
      });
    };
    $[9] = getActionKind;
    $[10] = navigate;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handlePasskeyClick = t3;
  let t4;
  if ($[12] !== onAuthMethodsDone) {
    t4 = () => {
      onAuthMethodsDone?.();
    };
    $[12] = onAuthMethodsDone;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleDone = t4;
  let t5;
  if ($[14] !== authMethods || $[15] !== decryptedEmail || $[16] !== decryptedPhone || $[17] !== deviceInfo || $[18] !== handleDone || $[19] !== handleEmailClick || $[20] !== handlePasskeyClick || $[21] !== handlePhoneClick) {
    t5 = <Dashboard methods={authMethods} decryptedEmail={decryptedEmail} decryptedPhone={decryptedPhone} deviceInfo={deviceInfo} isInIframe={isInIframe} onEmailClick={handleEmailClick} onPhoneClick={handlePhoneClick} onPasskeyClick={handlePasskeyClick} onDone={handleDone} />;
    $[14] = authMethods;
    $[15] = decryptedEmail;
    $[16] = decryptedPhone;
    $[17] = deviceInfo;
    $[18] = handleDone;
    $[19] = handleEmailClick;
    $[20] = handlePasskeyClick;
    $[21] = handlePhoneClick;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}